import { useMemo } from "react";
import { Form } from "antd";
import { useNumberParams } from "hooks/useNumberParams";
import { useEventDetailsQuery } from "@ticketingplatform/api/dist/event/hooks";
import { EventType } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { EventFormValues } from "../EventForm/types";

import { UseEventDetails, UseEventDetailsReturnType } from "./types";
import { parseEventDataToFormValues } from "./utils";

export const useEventDetails: UseEventDetails = () => {
  const [form] = Form.useForm<EventFormValues>();
  const { id } = useNumberParams(true);
  const { data, loading } = useEventDetailsQuery({
    variables: {
      id,
      venueInclude: false,
      imageInclude: true,
      seatMapInclude: true,
      ticketPoolsInclude: true,
      ticketPoolsTake: -1,
      presalePasswordsInclude: true,
      presalePasswordsTake: -1,
      discountCodesInclude: true,
      discountCodesTake: -1,
      includePreviewId: true,
    },
  });

  return useMemo<UseEventDetailsReturnType>(
    () => ({
      loading,
      form: {
        initialValues: parseEventDataToFormValues(data),
        disabled: true,
        eventType: data?.event?.type || EventType.TICKETED,
        eventStatus: data?.event?.status,
        form,
      },
      urls: {
        preview: data?.event?.previewId || "",
        eventDetails: data?.event?.eventOccuranceId || "",
      },
    }),
    [data, form, loading]
  );
};
